<div class="w-full">
    <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
        <h6 *ngIf="!phaseDetails" mat-dialog-title class="font-semibold primary-font">{{'text.project.phase.create'
            | translate}}</h6>
        <h6 *ngIf="phaseDetails" mat-dialog-title class="font-semibold primary-font">{{'text.project.phase.update'
            | translate}}</h6>
        <div class="flex items-center mr-1">
            <span mat-dialog-close class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
              <em class="ti ti-x text-xl font-bold"></em>
            </span>
        </div>
    </div>
    <div class="flex flex-col">
        <form [formGroup]="phaseFormGroup" class="w-full" ngNativeValidate>
            <div class="zuper-dialog-body">
                <div class="w-full">
                    <mat-form-field class="example-full-width" appearance="fill" ngClass="w-full" [hideRequiredMarker]="true">
                        <mat-label class="required primary-font font-semibold">{{'name.text' | translate}}</mat-label>
                        <input type="text" matInput id="remarks" name="name" class="form-control" formControlName="name" autocomplete="off" placeholder="{{'name.text' | translate}}"/>
                        <mat-error *ngIf="phaseFormGroup?.controls?.name?.invalid && phaseFormGroup?.controls?.name?.touched" class="primary-font font-semibold text-base">
                            {{'text.field_is_required' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="w-full mt-3">
                    <mat-label class="primary-font text-base font-semibold">{{'text.project.phase.color' | translate}}</mat-label>
                    <div class="color-picker mt-3">
                        <div *ngFor="let color of colors" 
                             [ngStyle]="{'background-color': color}" 
                             class="color-box" 
                             [class.selected]="selectedColor === color"
                             (click)="selectColor(color)">
                        </div>
                      </div>
                </div>
            </div>
            <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
                <div class="space-x-3">
                    <button mat-stroked-button [mat-dialog-close]="{status: false}" class="btn-small px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none" type="button">{{'cancel.text' | translate}}</button>
                    <button *ngIf="!phaseDetails" mat-stroked-button class="btn-small bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none" (click)="createNewPhase()">{{'create' | translate}}</button>
                    <button *ngIf="phaseDetails" mat-stroked-button class="btn-small bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none" (click)="updatePhase()">{{'update' | translate}}</button>
                </div>
            </div>
        </form>
    </div>
</div>